module.exports = __webpack_public_path__ + "static/media/10.06dd3636.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/lhand/10.png
// module id = 750
// module chunks = 0